<body>
    <div class="reset-password-container">
        <div class="col-md-6 col-lg-5 d-none d-md-block triangle">
            <img src="../../../../assets/logo/EMP.png" alt="reset password form" class="img-fluid"
                style="margin-left: 94px;" />
        </div>
        <h2>Reset Password</h2>
        <p>Please enter your new password.</p>
        <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">

            <div class="input-group">
                <input [type]="showNewPassword ? 'text' : 'password'" formControlName="vendorPassword"
                    placeholder="Enter New Password" required />
                <span class="eye-icon" (click)="toggleNewPasswordVisibility()">
                    <i class="fa" [ngClass]="showNewPassword ? 'fa-eye' : 'fa-eye-slash'"></i>
                </span>
                <div *ngIf="resetPasswordForm.get('vendorPassword')?.invalid && resetPasswordForm.get('vendorPassword')?.touched"
                    class="error-message">
                    Password is required and must be at least 6 characters.
                </div>
            </div>

            <div class="input-group">
                <input [type]="showConfirmPassword ? 'text' : 'password'" formControlName="confirmPassword"
                    placeholder="Enter Confirm Password" required />
                <span class="eye-icon" (click)="toggleConfirmPasswordVisibility()">
                    <i class="fa" [ngClass]="showConfirmPassword ? 'fa-eye' : 'fa-eye-slash'"></i>
                </span>
                <div *ngIf="resetPasswordForm.hasError('passwordMismatch') && resetPasswordForm.get('confirmPassword')?.touched"
                    class="error-message">
                    Passwords must match.
                </div>
            </div>

            <button type="submit" [disabled]="resetPasswordForm.invalid || isSubmitting">
                {{ isSubmitting ? 'Resetting...' : 'Reset Password' }}
            </button>
        </form>


        <a class="text-center" href="/vendor-login">Back to Login</a>
    </div>
</body>